import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./hamburger.css";


function HamburgerMenu({ leftItems, centerItem, rightItems }) {
  const [open, setOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (label) => {
  setOpenDropdowns((prev) => ({
    ...prev,
    [label]: !prev[label],
  }));
};

  const navItems = [
  centerItem,
  ...leftItems,
  ...rightItems,
];


  // Lock scroll when open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  return (
    <div className="hamburger-container">

      <button
        className={`hamburger-button ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      <div
        className={`menu-overlay ${open ? "active" : ""}`}
        onClick={() => setOpen(false)}
      >
        <div
          className="menu-panel"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="close-button"
            onClick={() => setOpen(false)}
          >
            ✕
          </button>
          <nav className="menu-list">
            {navItems.map((item) => {
              if (item.type === "dropdown") {
                const isOpen = openDropdowns[item.label];

                return (
                  <div key={item.label} className="mobile-dropdown">
                    <button
                      className="menu-item mobile-dropdown-title"
                      onClick={() => toggleDropdown(item.label)}
                    >
                      <span>{item.label}</span>

                      <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>
                        ▶
                      </span>
                    </button>

                    <div
                      className={`mobile-dropdown-menu ${isOpen ? "open" : ""}`}
                    >
                      {item.children.map((child) => (
                        <NavLink
                          key={child.path}
                          to={child.path}
                          className="menu-item"
                          onClick={() => setOpen(false)}
                        >
                          {child.label}
                        </NavLink>
                      ))}
                    </div>
                  </div>
                );
              }

              return (
                <NavLink
                  key={item.path || item.label}
                  to={item.path}
                  className="menu-item"
                  onClick={() => setOpen(false)}
                >
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}

export default HamburgerMenu;